export interface OpportunitiesListMapperI {
    select: boolean;
    id: string;
    name: string;
    accountName: string;
    contactName: string;
    leadSource: string;
    opportunityType: string;
    salesStage: string;
    amount: string;
    salesRep: string;
    dateCreated: string;
    opportunityNo: string;
    dateModified: string;
    probability: string;
    productionManagerName: string;
    salesManagerName: string;
    assignedSourcingRep: string;
    csrName: string;
    createdBy: string;
    dateClosed: string;
    inhandsDate: string;
    eventDate: string;
}
  